import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Grid, Button, CircularProgress } from '@nextiva/next-ui-components';

import { DialogStyles } from './Dialog.styles';

export function PlatformDialog({
  cancelButtonText = 'Cancel',
  cancelClick = undefined,
  children,
  header: propHeader = '',
  isLoading = false,
  message: propMessage = '',
  okButtonText = 'OK',
  okClick = () => {},
  open: propOpen = false,
  type = 'default',
}) {
  return (
    <DialogStyles aria-labelledby="simple-dialog-title" open={propOpen}>
      <div className="m-dialog">
        <div className={clsx('m-dialog__header', type)}>
          <span
            className="m-dialog__header__text Heading4"
            data-testid="PlatformAdminUI-TeamVoiceSettings-Dialog-Header"
          >
            {propHeader}
          </span>
        </div>
        <div
          className="m-dialog__content"
          data-testid="PlatformAdminUI-TeamVoiceSettings-Dialog-Content"
        >
          {propMessage && (
            <span className="m-dialog__content__text">{propMessage}</span>
          )}
          {children}
        </div>
        <div
          className="m-dialog__action-bar"
          data-testid="PlatformAdminUI-TeamVoiceSettings-Dialog-ActionBar"
        >
          <Grid alignItems="center" container spacing={2}>
            <Grid item xs>
              <Button
                disabled={isLoading}
                fullWidth
                color="primary"
                variant="contained"
                className={clsx('m-dialog__action-bar__button', type)}
                onClick={okClick}
                data-testid={`PlatformAdminUI-TeamVoiceSettings-Dialog-${okButtonText}`}
              >
                {okButtonText}
              </Button>
            </Grid>
            {cancelClick && (
              <Grid item xs>
                <Button
                  disabled={isLoading}
                  fullWidth
                  color="secondary"
                  variant="contained"
                  className={clsx('m-dialog__action-bar__button')}
                  onClick={cancelClick}
                  data-testid={`PlatformAdminUI-TeamVoiceSettings-Dialog-${cancelButtonText}`}
                >
                  {cancelButtonText}
                </Button>
              </Grid>
            )}
            {isLoading && <CircularProgress />}
          </Grid>
        </div>
      </div>
    </DialogStyles>
  );
}

PlatformDialog.propTypes = {
  okClick: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  cancelClick: PropTypes.func,
  children: PropTypes.node,
  header: PropTypes.string,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  okButtonText: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
};
